import { composeIO } from 'react-compose-io'
import { tabelaResultadoOPSIO } from './TabelaResultadosOPS.IO'
import TabelaResultadoOPSView from './TabelaResultadosOPS.View'

export const TabelaResultadoOPS = composeIO(TabelaResultadoOPSView, tabelaResultadoOPSIO)
